import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {forkJoin} from 'rxjs';
import {ApiService, HttpError} from '../../shared/api.service';
import {AuthService} from '../../shared/auth.service';
import {NavigationService} from '../../shared/navigation.service';

@Component({
  selector: 'display-form',
  templateUrl: './display-form.component.html',
  styleUrls: ['../styles/account-form.scss', './display-form.component.scss']
})
export class DisplayFormComponent implements OnInit {

  displayInformation: FormGroup;
  localeDescriptions: Map<number, string> = new Map();
  languages: Map<number, string> = new Map();
  isLoading = false;
  masquerading$ = this.Auth.masquerading$;

  get localeId() {
    return this.displayInformation.get('localeId');
  }

  constructor(private formBuilder: FormBuilder,
              private Api: ApiService,
              private Navigation: NavigationService,
              private Auth: AuthService) {
  }

  ngOnInit() {
    this.initializeForm();
    this.loadData();
  }

  initializeForm() {
    this.displayInformation = this.formBuilder.group({
      localeId: [''],
    });
  }

  loadData() {
    this.isLoading = true;

    forkJoin(
      this.Api.getLocaleList(),
      this.Api.getDisplaySettings()
    ).subscribe(([localeResponse, displayResponse]) => {
      this.updateForm(localeResponse, displayResponse);
      this.isLoading = false;
    }, (err: HttpError) => {
      this.handleError(err);
    });
  }

  updateForm(localeResponse: LocaleListDropdownResponse, displayResponse: DisplaySettings) {
    this.displayInformation.patchValue(displayResponse, {onlySelf: true});
    this.localeDescriptions = new Map();
    this.languages = new Map();

    for (const locale of localeResponse.locales) {
      this.localeDescriptions.set(locale.id, locale.description);
      this.languages.set(locale.id, locale.locale);
    }
  }

  update() {
    if (this.masquerading$.getValue()) {
      return;
    }
    this.isLoading = true;

    this.Api.updateDisplaySettings(this.displayInformation.value)
      .subscribe(() => {
        this.isLoading = false;
        this.updateUserLocale();
      }, (err: HttpError) => {
        this.handleError(err);
      });
  }

  updateUserLocale() {
    const user = {...this.Auth.user$.getValue()};
    user.locale = this.getLanguage();
    this.Auth.user$.next(user);
  }

  getLanguage() {
    return this.languages.get(this.localeId.value);
  }

  handleError(err: HttpError) {
    this.isLoading = false;
    this.Navigation.handleError(err);
  }
}
